import { toast } from 'material-react-toastify';
import { WishlistLine } from '../../interfaces/Wishlist/WishlistLine';
import { TableColumn } from '../../components/DataTable/TableColumn';
import { ImageColumn } from '../../components/DataTable/ImageColumn';
import { TextColumn } from '../../components/DataTable/TextColumn';
import { BoolColumn } from '../../components/DataTable/BoolColumn';
import { DataTable } from '../../components/DataTable/DataTable';
import { removeProductFromWishlist } from '../../api/Wishlist';
import { ButtonColumn } from '../../components/DataTable/ButtonColumn';
import { PriceColumn } from '../../components/DataTable/PriceColumn';

const columns: TableColumn<WishlistLine>[] = [
  {
    id: 'image',
    name: 'Resim',
    accessor: (row) => <ImageColumn url={row.product.baseImage.path} />,
    align: 'center',
  },
  {
    id: 'name',
    name: 'İsim',
    accessor: (row) => <TextColumn value={row.product.name} />,
  },
  {
    id: 'stock',
    name: 'Stok',
    accessor: (row) => <BoolColumn value={!!row.product.qty} />,
    align: 'center',
  },
  {
    id: 'price',
    name: 'Fiyat',
    accessor: (row) => (
      <PriceColumn
        value={row.product.price.amount}
        specialValue={row.product.specialPrice?.amount}
      />
    ),
  },
];

type WishlistTableProps = {
  lines: WishlistLine[];
  onUpdate: () => void;
};

export const WishlistTable = ({ lines, onUpdate }: WishlistTableProps) => {
  const handleDelete = (productID: number) => {
    removeProductFromWishlist(productID)
      .then(() => {
        toast.success('Ürün favorilerden silindi');
        onUpdate();
      })
      .catch((err) => toast.error(err.message));
  };

  const deleteColumn: TableColumn<WishlistLine> = {
    id: 'delete',
    name: 'İşlem',
    accessor: (row) => (
      <ButtonColumn label='Sil' onClick={() => handleDelete(row.productID)} />
    ),
    align: 'center',
  };

  return (
    <DataTable
      columns={[...columns, deleteColumn]}
      totalCount={lines.length}
      rows={lines}
      hidePagination
      linkGenerator={(line) => `/urun/${line.product.slug}`}
    />
  );
};
